module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class='gis-map-controls-tools gl-pointer' on-mouseleave=\"onToolsMouseLeave\" on-mouseenter=\"onToolsMouseEnter\">\n    <div class=\"icon-16 icon-wrench\" title='Инструменты' on-click=\"onToolsButtonClick\"></div>\n    <div class=\"tools-container\" name=\"tools\">\n        <div>\n            <div class=\"tool\" name=\"measure-tool\">\n                <h4 class=\"title\">Измерения</h4>\n                <label>\n                    <input type=\"checkbox\" name=\"measure\" value=\"distance\" on-change=\"onMeasureChange\">\n                    Измерить расстояние\n                </label><br/>\n                <label>\n                    <input type=\"checkbox\" name=\"measure\" value=\"area\" on-change=\"onMeasureChange\">\n                    Измерить площадь\n                </label>\n            </div>\n            <hr/>\n            <div class=\"tools\" name=\"compare-tool\">\n                <h4 class=\"title\">Сравнение слоев</h4>\n                <label>\n                    <input type=\"checkbox\" name=\"compare\" on-change=\"onCompareChange\">\n                    Включить сравнение\n                </label>\n            </div>\n            <hr/>\n            <div class=\"tool\" name=\"user-views-tool\">\n                <h4 class=\"title\">Настройка представления</h4>\n                <span class=\"gis-underline gl-pointer link\" name=\"user-views\" on-click=\"onUserViewsClick\">\n                    Перейти к представлениям\n                </span>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}